import {logger} from 'yougile-util'
import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'

export const checkProjectPrefix = async (prefix: string): Promise<boolean> => {
  const companyId = globals.getCompanyId()

  if (!companyId || !prefix) {
    return false
  }

  try {
    const resp = await Backend.postJSON<{data: boolean}>(
      '/data/id-tasks/check-project-prefix',
      {
        ...Backend.loadCred(),
        companyId,
        prefix
      }
    )

    return resp.data
  } catch (e) {
    logger.error('Cannot check-project-prefix', e)
    return false
  }
}
